import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PromotionStep } from '@/types/promotion'

interface PromotionStepState {
  currentStep: PromotionStep
}

const initialState: PromotionStepState = {
  currentStep: PromotionStep.SETUP
}

const promotionStepSlice = createSlice({
  name: 'promotionStep',
  initialState,
  reducers: {
    setCurrentStep: (state, action: PayloadAction<PromotionStep>) => {
      state.currentStep = action.payload
    },
    resetStep: (state) => {
      state.currentStep = PromotionStep.SETUP
    }
  }
})

export const { setCurrentStep, resetStep } = promotionStepSlice.actions
export default promotionStepSlice.reducer 
